var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("layout",function(){return [_c('li',{class:_vm.itemClass,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c(_vm.icon,{tag:"component",staticClass:"dropdown__icon"}):_vm._e(),_vm._t("default")],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }